import { Box } from '@mui/material';
import { Theme } from '@mui/material/styles';
import React, { FC, ReactElement } from 'react';

interface Props {
  /** Whether the photo was declined by the censor, which is what the colour says. */
  declined: boolean;
}

/**
 * The coloured dot that tells a censorship verdict apart before the words beside it are read: green
 * for a photo that passed, red for one that did not. The group headings and the full-screen view
 * draw the same dot, so a photo reads the same wherever it is looked at.
 */
export const VerdictDot: FC<Props> = (props: Props): ReactElement => {
  const { declined } = props;

  return (
    <Box
      aria-label={declined ? 'photo-declined-dot' : 'photo-delivered-dot'}
      sx={(theme: Theme) => ({
        width: '8px',
        height: '8px',
        borderRadius: '50%',
        flexShrink: 0,
        backgroundColor: declined ? theme.colors.red : theme.colors.success,
      })}
    />
  );
};
